// src-mlr-chakra/app.module.js

"use strict";

import angular from 'angular';
import config from 'app/config';
import appConfig from './app.config';
import routing from './app.route';
import routingDynamic from './app.route.dynamic';

import views from './views/views.module';
import commonComponents from './components/components.module';
import commonDirectives from '@common/directives/directives.module';
import commonFilters from '@common/filters/filters.module';
import commonServices from '@common/services/services.module';

import '@uirouter/angularjs';
import 'oclazyload';
import 'angular-sanitize';
import 'app/common/app.scss';

const dependencies = [
  'ui.router',
  'oc.lazyLoad',
  'ngSanitize',
  views,
  commonComponents,
  commonDirectives,
  commonFilters,
  commonServices,
];

angular
  .module(config.appName, dependencies)
  .config(appConfig)
  .config(routing)
  .run(routingDynamic);

angular.element(() => {
  angular.bootstrap(document, [config.appName], { strictDi: true });
});
